import { useCallback, useEffect, useState } from 'react'
import {
  B2B_COPILOT_PLAN_DEMO_ASSISTANT_MSG_ID,
  B2B_COPILOT_PLAN_DEMO_THREAD_ID,
} from '@/features/chat/demo/b2bCopilotPlanDemo.js'

/**
 * @param {string | null | undefined} activeThreadId
 * @param {Array<{ id: string, role?: string, demoStreamActive?: boolean }>} [messages]
 */
export function useChatThreadPreamble(activeThreadId = null, messages = []) {
  const [preambleExpandedByAssistantId, setPreambleExpandedByAssistantId] = useState(
    /** @type {Record<string, boolean>} */({}),
  )

  useEffect(() => {
    if (activeThreadId !== B2B_COPILOT_PLAN_DEMO_THREAD_ID) return
    setPreambleExpandedByAssistantId((prev) => ({
      ...prev,
      [B2B_COPILOT_PLAN_DEMO_ASSISTANT_MSG_ID]: false,
    }))
  }, [activeThreadId])

  useEffect(() => {
    const streamingAssistants = messages.filter(
      (m) =>
        m &&
        typeof m === 'object' &&
        /** @type {{ role?: string, demoStreamActive?: boolean }} */ (m).role === 'assistant' &&
        /** @type {{ demoStreamActive?: boolean }} */ (m).demoStreamActive,
    )
    if (!streamingAssistants.length) return

    setPreambleExpandedByAssistantId((prev) => {
      const next = { ...prev }
      for (const assistant of streamingAssistants) {
        const id = /** @type {{ id: string }} */ (assistant).id
        const summary =
          typeof /** @type {{ thoughtSummary?: string }} */ (assistant).thoughtSummary === 'string'
            ? /** @type {{ thoughtSummary: string }} */ (assistant).thoughtSummary
            : ''
        next[id] = summary === 'Thinking…'
      }
      return next
    })
  }, [messages])

  const togglePreambleExpanded = useCallback((assistantMessageId) => {
    setPreambleExpandedByAssistantId((prev) => ({
      ...prev,
      [assistantMessageId]: !prev[assistantMessageId],
    }))
  }, [])

  return { preambleExpandedByAssistantId, togglePreambleExpanded }
}
